export default "dist/images/components-design-separator-control-slant-2.50e3178.png";